module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-crianza/bottle-ad31f6bfdf67b420ddc5ff86e2be60fd.png";